import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const button = css`
  height: ${spacing(25)};
  ${cssTheme.components.buttons.outline.border.token}: 1px solid ${cssTheme.colors.coldGray[250]};
  ${cssTheme.fonts.sizes.body2.token}: 18px;
`
export const icon = css`
  font-size: ${spacing(5)};
`

export const mobileIcon = css`
  block-size: ${spacing(4)};
  inline-size: ${spacing(4)};
  border-radius: 50%;
  background-color: ${cssTheme.default.day.text};
  color: ${cssTheme.default.day.textInvert};
`
